import { IUserContext } from 'contexts/UserContext';
import AdminRoles from '../constants/AdminRoles';

const READ_ONLY_USER_FIELDS = [
  'email',
  'phone_number',
  'primary_identifier',
] as const;

export function prepareUserUpdateInput(
  values: Record<string, any>,
): Record<string, any> {
  const input = { ...values };
  READ_ONLY_USER_FIELDS.forEach((field) => delete input[field]);
  return input;
}

export function isAnyClientAdmin(user: IUserContext): boolean {
  const curUserRole = user.dbUser?.role_id;
  return (
    curUserRole === AdminRoles.Member ||
    curUserRole === AdminRoles.Manager ||
    curUserRole === AdminRoles.Administrator
  );
}

export function isAnyInternalAdmin(user: IUserContext): boolean {
  const curUserRole = user.dbUser?.role_id;
  return (
    curUserRole === AdminRoles.InternalMember ||
    curUserRole === AdminRoles.InternalManager ||
    curUserRole === AdminRoles.InternalAdministrator ||
    curUserRole === AdminRoles.SuperAdmin
  );
}

export function getUserInitials(user: IUserContext): string | undefined {
  const { dbUser } = user;

  if (!dbUser) {
    return;
  }

  const { email, full_name } = dbUser;

  const trimmedFullName = full_name?.trim();

  if (trimmedFullName) {
    const [first_name, last_name] = trimmedFullName.split(' ');

    if (first_name && last_name) {
      return [first_name[0], last_name[0]].map((l) => l.toUpperCase()).join('');
    }

    if (first_name) {
      return first_name[0].toUpperCase();
    }

    if (last_name) {
      return last_name[0].toUpperCase();
    }
  }

  return email?.[0]?.toUpperCase() || '';
}
